import { Observable } from 'rxjs';
import httpService from './httpService';
import {
  TripLegPackage,
  TripLegPackageDecisionResponse,
  TripLegPackagesResponse,
} from '../data/models/trip-leg-package.model';
import { TripLegPackagesRequest } from '../data/requests/trip-legs-packages';

class TripLegInventoryService {
  private readonly apiBase;
  private readonly apiTripBase;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBase = __environment__.REACT_APP_TRIP_LEG_PACKAGE_API_URL.trim();
    this.apiTripBase = __environment__.REACT_APP_TRIP_API_URL.trim();
  }

  public getOfferedPackages(
    request: TripLegPackagesRequest,
  ): Observable<TripLegPackagesResponse> {
    const ARRAY_PARAMS = new Set(['tripLegPackageStates']);

    const queryParams = Object.entries({
      ...request,
      // set default if non is passed
      ...(!request.tripLegPackageStates && {
        tripLegPackageStates: ['active'],
      }),
    })
      .filter(([_, value]) => value !== undefined && value !== null)
      .map(([key, value]) => {
        if (ARRAY_PARAMS.has(key) && Array.isArray(value)) {
          return `${encodeURIComponent(key)}=${encodeURIComponent(
            (value as string[]).join(','),
          )}`;
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(
          value?.toString() ?? '',
        )}`;
      })
      .join('&');

    const url = `${this.apiBase}?${queryParams}`;
    return httpService.getJSON(url);
  }

  public getTripLegPackage(
    providerID: number,
    packageUUID: string,
  ): Observable<TripLegPackage> {
    const url = `${this.apiBase}/${providerID}/${packageUUID}`;
    return httpService.getJSON(url);
  }

  public acceptTripPackage(
    packageUUID: string,
  ): Observable<TripLegPackageDecisionResponse> {
    const url = `${this.apiTripBase}/accept-package`;
    return httpService.postJSON(url, { packageUUID });
  }

  public rejectTripPackage(
    packageUUID: string,
    tripLegPackageStatusReasonBC: string,
  ): Observable<TripLegPackageDecisionResponse> {
    const url = `${this.apiTripBase}/reject-package`;
    return httpService.postJSON(url, {
      packageUUID,
      tripLegPackageStatusReasonBC,
    });
  }
}

const tripLegInventoryService = new TripLegInventoryService();

export default tripLegInventoryService;
